import moment from 'moment'

class MonthIterator {
    constructor(monthOrDate, year) {

        let month = 0
        if (monthOrDate instanceof Date) {
            month = monthOrDate.getMonth()+1
            year = monthOrDate.getFullYear()
        }            
        else    
            month = monthOrDate        

        if (month === undefined)
            throw new Error('Month value is undefined')

        if (month < 1 || month > 12)
            throw new Error('MonthIterator uses [1..12] month indexes')                    

        this.month = month
        this.year = year
    }

    toString(fmt) {
        let date = this.toDate()

        if(fmt === undefined)
            fmt = 'MMMM'

        switch(fmt) {
            case '$month':
                fmt = 'MMMM'
                break;
        }            

        return moment(date).format(fmt)
    }

    toDate() {
        let year = this.year
        if (year === undefined)
            year = (new Date()).getFullYear()

        return new Date(year, this.month - 1)
    }

    nextMonth() {
        let month = this.month + 1
        if (month == 13) {
            month = 1
            this.nextYear()
        }
        this.month = month
        return this
    }

    prevMonth() {
        let month = this.month - 1
        if (month == 0) {
            month = 12
            this.prevYear()
        }
        this.month = month
        return this
    }

    nextYear() {
        if (this.year !== undefined) {
            this.year++
        }
    }

    prevYear() {
        if (this.year !== undefined) {
            this.year--
        }
    }
}

export default MonthIterator